import Head from 'next/head';
import React from 'react';
import { withLayout } from '../Layout/Layout';
import { MembershipClub } from '../components/MembershipClub/MembershipClub';

export const MembershipClubHOC = ({ authCompleted, setLoginDialogState }) => {
  return (
    <>
      <Head>
        <link rel="canonical" href={`${process.env.apiUrl}/club`} />
        <meta
          name="description"
          content={
            'First-Class.com - The Club makes travel planning easy by combining the best deal search and booking in one place. We conduct extensive searches across thousands of airlines and online travel agents, allowing you to compare prices transparently on our website.'
          }
        />
        <title>The Club | Best Travel Membership Club | Exclusive Luxury Travel</title>
      </Head>
      <MembershipClub authCompleted={authCompleted} setLoginDialogState={setLoginDialogState} />
    </>
  );
};
export default withLayout(MembershipClubHOC, true);
